"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ScheduleIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M19 10.341V7.006A2 2 0 0 0 17.006 5H4.994A2 2 0 0 0 3 7.006v9.988A2 2 0 0 0 4.994 19h6.809a6 6 0 0 1-.72-2.001c-3.028 0-6.083-.002-6.083-.005C5 16.994 5 7 4.994 7 4.994 7 17 7 17 7.006V10c.701 0 1.374.12 2 .341"/><path d="M5 4v1h2V4a1 1 0 0 0-2 0m10 0v1h2V4a1 1 0 0 0-2 0M4 7h14v2H4zm14 8v-1.01a1 1 0 0 0-1-.99c-.56 0-1 .44-1 .99V15h-1.01a1 1 0 0 0-.99 1c0 .56.44 1 .99 1H16v1.01a1 1 0 0 0 1 .99c.56 0 1-.44 1-.99V17h1.01a1 1 0 0 0 .99-1c0-.56-.44-1-.99-1zm-1 6a5 5 0 1 1 0-10 5 5 0 0 1 0 10"/></g></svg>`
}, props));
ScheduleIcon.displayName = 'ScheduleIcon';
var _default = exports.default = ScheduleIcon;